<script>
export default {
  name: 'CollapseButton',
  components: {},
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      
    };
  },
  computed: {
    
  },
  watch: {},
  mounted() {
    
  },
  methods: {
    
  }
}
</script>

<template>
  <div class="collapse-btn" @click="$emit('input', !value)">
    <span>{{ value ? '收起' : '展开' }}</span>
    <i :class="{ active: value }" class="el-icon-arrow-down"></i>
  </div>
</template>

<style lang="scss" scoped>
.collapse-btn {
  user-select: none;
  cursor: pointer;
  color: var(--color-primary);

  .el-icon-arrow-down {
    transition: transform 0.3s;
  }

  .el-icon-arrow-down.active {
    transform: rotate(180deg);
  }
}
</style>